var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pop-message-list",
    attrs: {
      id: "messge-container"
    }
  }, [_c("messageDetailModel", {
    attrs: {
      "message-info": _vm.messageDetailData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };